var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.28995 12 12 9.28551 12 5.99713C12 2.70875 9.28421 0 6 0C2.71005 0 0 2.70875 0 5.99713C0 9.28551 2.71005 12 6 12ZM5.36268 8.85509C5.12153 8.85509 4.93206 8.75179 4.75981 8.53945L3.38182 6.88092C3.26699 6.73171 3.21531 6.59397 3.21531 6.43902C3.21531 6.11191 3.47368 5.85366 3.80096 5.85366C3.99043 5.85366 4.13971 5.92826 4.289 6.11191L5.34545 7.42611L7.64785 3.75323C7.78565 3.52941 7.96364 3.42037 8.16459 3.42037C8.48612 3.42037 8.77321 3.64993 8.77321 3.97704C8.77321 4.11478 8.71005 4.26399 8.61818 4.40172L5.93684 8.52798C5.79904 8.74032 5.59234 8.85509 5.36268 8.85509Z",
    fill: "#A41A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.98652564d9bf9808111d115f046e584d.svg";
export { ForwardRef as ReactComponent };